// Animation presets shared by the editor, Visor and export.
// Pan (Ken Burns) only scales around a transform-origin, so no edge gap shows.
export const PAN_SCALE = 1.15;

export const textAnimationPresets = [
  {
    name: "Fade In",
    animation: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide In Right",
    animation: {
      initial: { x: 100, opacity: 0 },
      animate: { x: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide In Left",
    animation: {
      initial: { x: -100, opacity: 0 },
      animate: { x: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide In Up",
    animation: {
      initial: { y: 100, opacity: 0 },
      animate: { y: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide In Down",
    animation: {
      initial: { y: -100, opacity: 0 },
      animate: { y: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Scale In",
    animation: {
      initial: { scale: 0, opacity: 0 },
      animate: { scale: 1, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Rotate In",
    animation: {
      initial: { rotate: -180, opacity: 0 },
      animate: { rotate: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Bounce In",
    animation: {
      initial: { scale: 0, opacity: 0 },
      animate: { scale: 1, opacity: 1 },
      transition: { duration: 1, ease: "backOutStrong" },
    },
  },
  {
    name: "Type Writer",
    animation: {
      initial: { width: 0 },
      animate: { width: "auto" },
      transition: { duration: 2, ease: "linear" },
    },
  },
  {
    name: "Wavy Text",
    animation: {
      initial: {},
      animate: {},
      transition: { duration: 2 },
      isWavy: true,
    },
  },
];

// Old preset names saved in existing content.
const LEGACY_ANIM_NAME_MAP = {
  Zoom: "Scale In",
  "Zoom In": "Scale In",
  FadeIn: "Fade",
  "Fade In": "Fade",
  SlideRight: "Slide In Right",
  SlideLeft: "Slide In Left",
  SlideUp: "Slide In Up",
  SlideDown: "Slide In Down",
  RotateIn: "Rotate In",
  BounceIn: "Bounce In",
};

export function normalizeAnimationName(name) {
  if (!name) return name;
  return LEGACY_ANIM_NAME_MAP[name] ?? name;
}

export const boxAnimationPresets = [
  {
    name: "Fade",
    animation: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Fade In",
    animation: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide In Right",
    animation: {
      initial: { x: 100, opacity: 0 },
      animate: { x: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide In Left",
    animation: {
      initial: { x: -100, opacity: 0 },
      animate: { x: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide In Up",
    animation: {
      initial: { y: 100, opacity: 0 },
      animate: { y: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide In Down",
    animation: {
      initial: { y: -100, opacity: 0 },
      animate: { y: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Scale In",
    animation: {
      initial: { scale: 0.5, opacity: 0 },
      animate: { scale: 1, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Rotate",
    animation: {
      initial: { rotate: -90, opacity: 0 },
      animate: { rotate: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Bounce",
    animation: {
      // Zıpla drops from above and bounces vertically; Bounce In pops in place.
      initial: { y: -80, opacity: 0 },
      animate: { y: 0, opacity: 1 },
      transition: { duration: 1, ease: "bounceOut" },
    },
  },
  {
    name: "Bounce In",
    animation: {
      initial: { scale: 0, opacity: 0 },
      animate: { scale: 1, opacity: 1 },
      transition: { duration: 1, ease: "backOutStrong" },
    },
  },
  {
    name: "Rotate In",
    animation: {
      initial: { rotate: -180, opacity: 0 },
      animate: { rotate: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Type Writer",
    animation: {
      initial: { width: 0 },
      animate: { width: "auto" },
      transition: { duration: 2, ease: "linear" },
    },
  },
  {
    name: "Wavy Text",
    animation: {
      initial: {},
      animate: {},
      transition: { duration: 2 },
      isWavy: true,
    },
  },
  {
    name: "Flip",
    animation: {
      initial: { rotateY: 90, opacity: 0 },
      animate: { rotateY: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Pinwheel",
    animation: {
      initial: { rotate: -360, scale: 0, opacity: 0 },
      animate: { rotate: 0, scale: 1, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Roll",
    animation: {
      initial: { x: -200, rotate: -360, opacity: 0 },
      animate: { x: 0, rotate: 0, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Stretch",
    animation: {
      initial: { scaleX: 0, opacity: 0 },
      animate: { scaleX: 1, opacity: 1 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Pan",
    animation: {
      initial: { scale: PAN_SCALE },
      animate: { scale: 1 },
      transition: { duration: 1.4, ease: [0.25, 0.46, 0.45, 0.94] },
    },
  },
];

export const boxExitAnimationPresets = [
  {
    name: "Fade Out",
    animation: {
      initial: { opacity: 1 },
      animate: { opacity: 0 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide Out Right",
    animation: {
      initial: { x: 0, opacity: 1 },
      animate: { x: 100, opacity: 0 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide Out Left",
    animation: {
      initial: { x: 0, opacity: 1 },
      animate: { x: -100, opacity: 0 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide Out Up",
    animation: {
      initial: { y: 0, opacity: 1 },
      animate: { y: -100, opacity: 0 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Slide Out Down",
    animation: {
      initial: { y: 0, opacity: 1 },
      animate: { y: 100, opacity: 0 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Scale Out",
    animation: {
      initial: { scale: 1, opacity: 1 },
      animate: { scale: 0.5, opacity: 0 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Rotate Out",
    animation: {
      initial: { rotate: 0, opacity: 1 },
      animate: { rotate: 90, opacity: 0 },
      transition: { duration: 1 },
    },
  },
  {
    name: "Bounce Out",
    animation: {
      initial: { scale: 1 },
      animate: { scale: 0 },
      transition: { duration: 1, type: "spring", bounce: 0.4 },
    },
  },
  {
    name: "Type Writer Out",
    animation: {
      initial: {},
      animate: {},
      transition: { duration: 1, ease: "linear" },
      isTypeWriterOut: true,
    },
  },
  {
    name: "Wavy Text Out",
    animation: {
      initial: {},
      animate: {},
      transition: { duration: 1 },
      isWavy: true,
    },
  },
  {
    name: "Pan Out",
    animation: {
      initial: { scale: PAN_SCALE },
      animate: { scale: 1 },
      transition: { duration: 1.4, ease: [0.25, 0.46, 0.45, 0.94] },
    },
  },
];

export const getTextAnimationPresets = () => textAnimationPresets;
export const getBoxAnimationPresets = () => boxAnimationPresets;
export const getBoxExitAnimationPresets = () => boxExitAnimationPresets;

// Returns { initial, animate, transition, ...flags } or null if unknown.
export function getAnimationTargets(name, type = "entry") {
  if (!name) return null;
  const resolved = normalizeAnimationName(name);
  const list = type === "exit" ? boxExitAnimationPresets : boxAnimationPresets;
  const preset = list.find((p) => p.name === resolved);
  return preset ? preset.animation : null;
}

// Default origins; panOriginX/Y and panDirection on the box override them.
export const _PAN_ENTRY_MAP = {
  Pan: { transformOrigin: "right center" },
};

export const _PAN_EXIT_MAP = {
  "Pan Out": { transformOrigin: "center center" },
};

export function _resolvePanConfig(basePan, animObj) {
  const scale =
    animObj && typeof animObj === "object" && animObj.panScale != null
      ? animObj.panScale
      : PAN_SCALE;
  let transformOrigin = basePan.transformOrigin;
  if (
    animObj &&
    typeof animObj === "object" &&
    (animObj.panOriginX != null || animObj.panOriginY != null)
  ) {
    const ox = animObj.panOriginX ?? 50;
    const oy = animObj.panOriginY ?? 50;
    transformOrigin = `${ox}% ${oy}%`;
  }
  // "out" (default) zooms from `scale` to 1; "in" zooms from 1 to `scale`.
  const zoomIn = animObj && typeof animObj === "object" && animObj.panDirection === "in";
  return {
    transformOrigin,
    initial: { scale: zoomIn ? 1 : scale },
    animate: { scale: zoomIn ? scale : 1 },
  };
}
